export const redirectURL = () => {
	if (window.location.pathname.length > 1) {
		return '?redirect=' + window.location.pathname;
	}
	return '';
};
